/* Camera preferences are order-line information, not inventory variants. */
(function () {
  'use strict';
  if (window.SmarketCameraOptions || !window.SmarketCameraOptionsData) return;
  var data = window.SmarketCameraOptionsData;
  var records = Object.create(null), resolving = Object.create(null);
  document.querySelectorAll('[data-smk-camera-config]').forEach(function (node) {
    try { var record = JSON.parse(node.textContent); if (record && record.id) records[record.id] = record; }
    catch (error) { console.warn('Invalid camera configuration JSON', error); }
  });
  function resolveProduct(id) {
    var record = records[id];
    if (!record || resolving[id]) return data.products[id];
    resolving[id] = true;
    record.variants.forEach(function (variant) { data.variants[variant] = id; });
    if (record.options !== null) {
      var value = record.options, key = 'product:' + id;
      var valid = value && value.version === 1 && typeof value.model === 'string' && Array.isArray(value.options) &&
        value.options.every(function (o) { return o && typeof o.lens === 'string' && o.lens.trim() && typeof o.colour === 'string' && o.colour.trim(); });
      var pairs = valid ? value.options : [];
      data.models[key] = {
        label: valid ? value.model : 'Camera',
        lenses: Array.from(new Set(pairs.map(function (o) { return o.lens; }))),
        colours: Array.from(new Set(pairs.map(function (o) { return o.colour; }))),
        stocked: pairs.map(function (o) { return o.lens + '|' + o.colour; }),
        allowed: pairs,
        lensDetails: valid && value.lens_details && typeof value.lens_details === 'object' ? value.lens_details : {}
      };
      data.products[id] = { groups: [{ model: key, count: 1 }], mixed: false, configured: true };
    } else if (record.bases.length) {
      // A mixed kit can opt into new inherited colour choices once its own
      // gallery has images for the combinations. Other kits keep their prior state.
      if (record.bases.length > 1 && !record.combo_ready && record.bases.some(function (base) {
        return records[base.id] && records[base.id].require_combo_for_mixed === true;
      })) { delete resolving[id]; return data.products[id]; }
      var groups = [], inherited = false, complete = true;
      record.bases.filter(function (base) { return Number(base.count) > 0; }).forEach(function (base) {
        var config = resolveProduct(base.id);
        if (!config) { complete = false; return; }
        inherited = inherited || !!config.configured;
        config.groups.forEach(function (group) { groups.push({ model: group.model, count: group.count * Number(base.count) }); });
      });
      // Never drop an unknown component of a mixed kit.
      if (inherited && complete && groups.length) data.products[id] = { groups: groups, mixed: groups.length > 1, uniformColour: groups.length > 1 && record.combo_ready, configured: true };
    }
    return data.products[id];
  }
  Object.keys(records).forEach(resolveProduct);
  var selections = Object.create(null);
  var mainProductId = '';
  var serial = 0;
  function closePicker(field, restoreFocus) {
    field.querySelector('.smk-camera-menu').hidden = true;
    field.querySelector('.smk-camera-trigger').setAttribute('aria-expanded', 'false');
    if (restoreFocus) field.querySelector('.smk-camera-trigger').focus({ preventScroll: true });
  }
  function closePickers(except) {
    document.querySelectorAll('.smk-camera-trigger[aria-expanded="true"]').forEach(function (button) {
      var field = button.closest('.smk-camera-field');
      if (field !== except) closePicker(field, false);
    });
  }

  function choice(model) {
    var definition = data.models[model];
    if (!selections[model]) selections[model] = definition.allowed ?
      Object.assign({}, definition.allowed[0] || { lens: '', colour: '' }) : { lens: '2.8mm', colour: 'White' };
    return selections[model];
  }
  function allowed(model, selected) {
    var definition = data.models[model];
    return !definition.allowed || definition.allowed.some(function (o) { return o.lens === selected.lens && o.colour === selected.colour; });
  }
  function unifyColour(config, colour) {
    if (!config || !config.uniformColour) return true;
    var proposed = config.groups.map(function (group) {
      var current = choice(group.model), definition = data.models[group.model];
      if (allowed(group.model, { lens: current.lens, colour: colour })) return { lens: current.lens, colour: colour };
      return definition.allowed && definition.allowed.find(function (pair) { return pair.colour === colour; });
    });
    if (proposed.some(function (pair) { return !pair; })) return false;
    config.groups.forEach(function (group, index) {
      var current = choice(group.model); current.lens = proposed[index].lens; current.colour = proposed[index].colour;
    });
    return true;
  }
  function available(config) {
    return !config || (config.groups.every(function (group) { return allowed(group.model, choice(group.model)); }) &&
      (!config.uniformColour || config.groups.every(function (group) { return choice(group.model).colour === choice(config.groups[0].model).colour; })));
  }
  function configForVariant(id) { return data.products[data.variants[String(id)]]; }
  // A read-only snapshot for display integrations. Order properties stay unchanged.
  function selection(productId) {
    var config = data.products[String(productId)];
    return {
      productId: String(productId),
      available: available(config),
      groups: config ? config.groups.map(function (group) {
        var selected = choice(group.model);
        return { model: group.model, count: group.count, lens: selected.lens, colour: selected.colour };
      }) : []
    };
  }
  function notifySelection(host) {
    var detail = selection(host._productId), signature = JSON.stringify(detail);
    if (host._selectionSignature === signature) return;
    host._selectionSignature = signature;
    host.dispatchEvent(new CustomEvent('smk:camera-selection-change', { bubbles: true, detail: detail }));
  }
  function special(model, selected) {
    return !data.models[model].allowed && data.models[model].stocked.indexOf(selected.lens + '|' + selected.colour) < 0;
  }
  function leadTime(model, selected) {
    var definition = data.models[model];
    if (definition.allowed) {
      var pair = definition.allowed.find(function (o) { return o.lens === selected.lens && o.colour === selected.colour; });
      return pair && typeof pair.eta === 'string' ? pair.eta : '';
    }
    return special(model, selected) ? data.eta : '';
  }
  function lensLabel(model, lens) {
    var details = data.models[model].lensDetails, entry = details && details[lens];
    return lens + (entry && typeof entry.horizontal_fov === 'string' ? ' (' + entry.horizontal_fov + ')' : '');
  }
  function candidate(model, preference, value) {
    var selected = Object.assign({}, choice(model)); selected[preference] = value;
    var definition = data.models[model];
    if (preference === 'lens' && definition.allowed && !allowed(model, selected)) {
      var pair = definition.allowed.find(function (o) { return o.lens === value; });
      if (pair) selected.colour = pair.colour;
    }
    return selected;
  }
  function properties(config) {
    if (!config || !available(config)) return {};
    var props = {}, signature = [], leadTimes = [];
    config.groups.forEach(function (group, index) {
      var selected = choice(group.model), model = data.models[group.model];
      var prefix = config.mixed ? 'Camera ' + (index + 1) + ' (' + model.label + ') — ' : '';
      props[prefix + 'Lens'] = selected.lens;
      props[prefix + 'Colour'] = selected.colour;
      signature.push([group.model, selected.lens, selected.colour]);
      var eta = leadTime(group.model, selected);
      if (eta) leadTimes.push(config.mixed ? model.label + ': ' + eta : eta);
    });
    if (leadTimes.length) props['Lead time'] = leadTimes.join('; ');
    props._camera_configuration = JSON.stringify(signature);
    return props;
  }
  function setInputs(form, props) {
    var desired = Object.keys(props);
    form.querySelectorAll('[data-smk-camera-property]').forEach(function (input) {
      if (desired.indexOf(input.dataset.smkCameraProperty) < 0) input.remove();
    });
    desired.forEach(function (key) {
      var input = Array.from(form.querySelectorAll('[data-smk-camera-property]')).find(function (el) { return el.dataset.smkCameraProperty === key; });
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden';
        input.dataset.smkCameraProperty = key; input.name = 'properties[' + key + ']'; form.appendChild(input);
      }
      input.value = props[key];
    });
  }
  function syncForms() {
    if (!mainProductId) return;
    document.querySelectorAll('form.js-main-product-form, form#productStickyForm').forEach(function (form) {
      // Other product forms (recommendations / quick views) are not affected.
      var idInput = form.querySelector('[name="id"]');
      var config = idInput && data.variants[idInput.value] === mainProductId ? configForVariant(idInput.value) : null;
      form.toggleAttribute('data-smk-camera-unavailable', !!config && !available(config));
      setInputs(form, properties(config));
    });
  }
  function refresh() {
    document.querySelectorAll('smk-camera-options').forEach(function (host) { host.updateSelection(); });
    syncForms();
  }
  function apply(item) {
    var config = configForVariant(item.id);
    if (config) item.properties = Object.assign({}, item.properties || {}, properties(config));
    return item;
  }
  function setVariant(container, variant) {
    var host = container.querySelector('smk-camera-options');
    if (host && typeof host.setProduct === 'function') host.setProduct(data.variants[String(variant)] || '');
  }
  window.SmarketCameraOptions = {
    selection: selection,
    apply: apply,
    properties: function (variant) { return properties(configForVariant(variant)); },
    setVariant: setVariant,
    available: function (variant) { return available(configForVariant(variant)); },
    sameConfiguration: function (line, item) {
      return ((line.properties || {})._camera_configuration || '') === ((item.properties || {})._camera_configuration || '');
    },
    context: function (variant) {
      var config = configForVariant(variant);
      return config ? config.groups.map(function (group) {
        var s = choice(group.model); return data.models[group.model].label + ': ' + s.lens + ' / ' + s.colour;
      }).join('; ') : '';
    }
  };

  class CameraOptions extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      if (this.hasAttribute('data-primary') || this.closest('form.js-main-product-form')) mainProductId = this.dataset.productId;
      this.setProduct(this.dataset.productId);
      this.addEventListener('change', function (event) {
        var select = event.target;
        if (!select.dataset.model || !select.dataset.preference) return;
        var m = data.models[select.dataset.model], value = select.value;
        var selected = choice(select.dataset.model);
        if (select.dataset.preference === 'lens' && m.lenses.indexOf(value) >= 0) {
          selected.lens = value;
          if (m.allowed && !allowed(select.dataset.model, selected)) selected.colour = m.allowed.find(function (o) { return o.lens === value; }).colour;
        }
        if (select.dataset.preference === 'colour' && (m.colours || ['White', 'Black']).indexOf(value) >= 0 &&
            allowed(select.dataset.model, { lens: selected.lens, colour: value })) selected.colour = value;
        if (this._config && this._config.uniformColour) unifyColour(this._config, selected.colour);
        refresh();
      });
      // If the bundle controller upgraded before this element was defined,
      // use its current kit selection rather than resetting to the base camera.
      var bundle = this.closest('sht-prd-bundle');
      if (bundle && bundle.state && bundle.state.kit) setVariant(bundle, bundle.state.kit.variant);
      syncForms();
    }
    setProduct(productId) {
      if (this._productId === productId) return;
      this._productId = productId;
      this._config = data.products[productId];
      if (this._config && this._config.uniformColour) unifyColour(this._config, choice(this._config.groups[0].model).colour);
      this.replaceChildren();
      this.hidden = !this._config;
      if (!this._config) { notifySelection(this); return; }
      var host = this;
      this._config.groups.forEach(function (group, groupIndex) {
        var model = data.models[group.model];
        var fieldset = document.createElement('fieldset'); fieldset.className = 'smk-camera-group';
        if (host._config.mixed) {
          var legend = document.createElement('legend'); legend.textContent = model.label + ' · ' + group.count + ' cameras'; fieldset.appendChild(legend);
        }
        if (model.allowed && !model.allowed.length) {
          var unavailable = document.createElement('p'); unavailable.className = 'smk-camera-unavailable';
          unavailable.textContent = 'No lens / colour combination is currently available.';
          unavailable.setAttribute('role', 'status'); fieldset.appendChild(unavailable); host.appendChild(fieldset);
          return;
        }
        var fields = document.createElement('div'); fields.className = 'smk-camera-fields';
        [['lens', 'Lens', model.lenses], ['colour', 'Colour', model.colours || ['White', 'Black']]].forEach(function (field) {
          var label = document.createElement('div'); label.className = 'smk-camera-field';
          if (host._config.uniformColour && field[0] === 'colour' && groupIndex > 0) label.hidden = true;
          var text = document.createElement('span'); text.className = 'smk-camera-label'; text.textContent = field[0] === 'lens' && model.lensDetails && Object.keys(model.lensDetails).length ? 'Lens · horizontal FOV' : (host._config.uniformColour && field[0] === 'colour' ? 'Colour · all cameras' : field[1]);
          var select = document.createElement('select'); select.id = 'smk-camera-' + (++serial); select.hidden = true; select.setAttribute('aria-label', field[1]);
          select.dataset.model = group.model; select.dataset.preference = field[0];
          field[2].forEach(function (value) { var opt = document.createElement('option'); opt.value = value; opt.textContent = value; select.appendChild(opt); });
          // A single supported value is a specification, not a choice.
          // Keep its select for the existing selection/form synchronisation.
          if (field[2].length === 1) {
            var fixed = document.createElement('span'); fixed.className = 'smk-camera-fixed';
            var fixedValue = document.createElement('span'); fixedValue.className = 'smk-camera-value';
            fixed.appendChild(text); fixed.appendChild(fixedValue);
            label.appendChild(fixed); label.appendChild(select); fields.appendChild(label);
            return;
          }
          var control = document.createElement('span'); control.className = 'smk-camera-select';
          var current = document.createElement('span'); current.className = 'smk-camera-value';
          var trigger = document.createElement('button'); trigger.type = 'button'; trigger.className = 'smk-camera-trigger'; trigger.setAttribute('aria-haspopup', 'listbox'); trigger.setAttribute('aria-expanded', 'false');
          trigger.dataset.preference = field[0]; trigger.appendChild(text); control.appendChild(current); trigger.appendChild(control);
          var menu = document.createElement('div'); menu.id = select.id + '-menu'; menu.className = 'smk-camera-menu'; menu.setAttribute('role', 'listbox'); menu.setAttribute('aria-label', field[1]); menu.hidden = true; trigger.setAttribute('aria-controls', menu.id);
          field[2].forEach(function (value) {
            var item = document.createElement('button'); item.type = 'button'; item.className = 'smk-camera-option'; item.setAttribute('role', 'option'); item.tabIndex = -1; item.dataset.value = value;
            var title = document.createElement('span'); title.textContent = value; item.appendChild(title);
            var eta = document.createElement('small'); eta.className = 'smk-camera-option-eta'; item.appendChild(eta);
            item.addEventListener('click', function () { select.value = value; select.dispatchEvent(new Event('change', { bubbles: true })); closePicker(label, true); });
            menu.appendChild(item);
          });
          function openPicker(last) {
            closePickers(label); menu.hidden = false; trigger.setAttribute('aria-expanded', 'true');
            var options = Array.from(menu.children).filter(function (item) { return !item.hidden; }), selected = options.find(function (item) { return item.dataset.value === select.value; });
            (last ? options[options.length - 1] : selected || options[0]).focus({ preventScroll: true });
          }
          trigger.addEventListener('click', function () { if (menu.hidden) openPicker(false); else closePicker(label, false); });
          trigger.addEventListener('keydown', function (event) { if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); openPicker(event.key === 'ArrowUp'); } });
          menu.addEventListener('keydown', function (event) {
            var options = Array.from(menu.children).filter(function (item) { return !item.hidden; }), index = options.indexOf(document.activeElement);
            if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) >= 0) {
              event.preventDefault(); var next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length; options[next].focus();
            } else if (event.key === 'Escape') { event.preventDefault(); closePicker(label, true); }
            else if (event.key === 'Tab') closePicker(label, true);
          });
          label.addEventListener('focusout', function () { setTimeout(function () { if (!label.contains(document.activeElement)) closePicker(label, false); }, 0); });
          label.appendChild(trigger); label.appendChild(select); label.appendChild(menu); fields.appendChild(label);
        });
        fieldset.appendChild(fields);
        var note = document.createElement('p'); note.className = 'smk-camera-eta'; note.id = 'smk-camera-eta-' + (++serial); note.dataset.model = group.model; note.setAttribute('role', 'status'); note.setAttribute('aria-live', 'polite');
        fields.querySelectorAll('.smk-camera-trigger').forEach(function (button) { button.setAttribute('aria-describedby', note.id); });
        fieldset.appendChild(note); host.appendChild(fieldset);
      });
      this.updateSelection();
    }
    updateSelection() {
      this.querySelectorAll('select').forEach(function (select) {
        select.value = choice(select.dataset.model)[select.dataset.preference];
        var valueNode = select.parentElement.querySelector('.smk-camera-value');
        valueNode.replaceChildren();
        var displayValue = select.dataset.preference === 'lens' ? lensLabel(select.dataset.model, select.value) : select.value;
        select.parentElement.classList.toggle('smk-camera-field--long', displayValue.length > 10);
        displayValue.split(' + ').forEach(function (part, index) {
          if (index) valueNode.appendChild(document.createTextNode(' + '));
          var span = document.createElement('span'); span.className = 'smk-camera-value-part'; span.textContent = part; valueNode.appendChild(span);
        });
        select.parentElement.querySelectorAll('.smk-camera-option').forEach(function (item) {
          var selected = candidate(select.dataset.model, select.dataset.preference, item.dataset.value);
          item.hidden = select.dataset.preference === 'colour' && !allowed(select.dataset.model, selected);
          item.setAttribute('aria-selected', String(item.dataset.value === select.value));
          item.firstElementChild.textContent = select.dataset.preference === 'lens' ? lensLabel(select.dataset.model, item.dataset.value) : item.dataset.value;
          var etaText = leadTime(select.dataset.model, selected);
          var eta = item.querySelector('.smk-camera-option-eta'); eta.hidden = !etaText; eta.textContent = etaText && special(select.dataset.model, selected) ? 'ETA 3–4 weeks' : etaText;
        });
        Array.from(select.options).forEach(function (option) {
          var s = candidate(select.dataset.model, select.dataset.preference, option.value);
          option.disabled = select.dataset.preference === 'colour' && !allowed(select.dataset.model, s);
          option.hidden = option.disabled;
          var etaText = leadTime(select.dataset.model, s);
          option.textContent = (select.dataset.preference === 'lens' ? lensLabel(select.dataset.model, option.value) : option.value) + (etaText ? ' — ' + (special(select.dataset.model, s) ? 'ETA 3–4 weeks' : etaText) : '');
        });
      });
      this.querySelectorAll('.smk-camera-eta').forEach(function (note) {
        var etaText = leadTime(note.dataset.model, choice(note.dataset.model));
        note.hidden = !etaText;
        note.textContent = etaText;
      });
      notifySelection(this);
    }
  }
  customElements.define('smk-camera-options', CameraOptions);
  document.addEventListener('pointerdown', function (event) { closePickers(event.target.closest('.smk-camera-field')); });
  // Populate the sticky form after the page is fully parsed, and after a
  // native variant update. No fetch interception or checkout interception.
  document.addEventListener('DOMContentLoaded', syncForms);
  document.addEventListener('change', syncForms);
  document.addEventListener('submit', syncForms, true);
  function guardNative(event) {
    var form = event.type === 'submit' ? event.target : event.target.closest('form.js-main-product-form, form#productStickyForm');
    if (event.type === 'click' && !event.target.closest('button[type="submit"], input[type="submit"], .js-product-form-submit-btn')) return;
    if (!form || !form.matches('form.js-main-product-form, form#productStickyForm')) return;
    var bundle = form.id === 'productStickyForm' && document.querySelector('sht-prd-bundle');
    // The sticky bundle route validates the selected kit, which may differ
    // from the single camera represented by the native form's variant.
    if (bundle && bundle._stickyActive) return;
    var variant = form.querySelector('[name="id"]');
    if (!variant || data.variants[variant.value] !== mainProductId || available(configForVariant(variant.value))) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var host = document.querySelector('smk-camera-options[data-primary]');
    if (host) host.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  window.addEventListener('click', guardNative, true);
  window.addEventListener('submit', guardNative, true);
  document.addEventListener('formdata', function (event) {
    var form = event.target;
    if (!form.matches('form.js-main-product-form, form#productStickyForm')) return;
    var variant = form.querySelector('[name="id"]');
    if (!variant || data.variants[variant.value] !== mainProductId) return;
    var props = properties(configForVariant(variant.value));
    Object.keys(props).forEach(function (key) { event.formData.set('properties[' + key + ']', props[key]); });
  }, true);
})();
